export const roundCompare = (x: number, y: number, precision: number) => {
    return x.toPrecision(precision) === y.toPrecision(precision);
  };
